/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component, PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './RealisationAccueil.css';
import fetch from '../../core/fetch';
import { Link } from 'react-router';


let boundItemClick = [];

@withStyles(s)
export default class RealisationAccueil extends Component{
    

    constructor(props) {
        super(props);

        this.state = {
            realisations: []
        };

    }

    componentDidMount(){

        this.GetRealisations();
    
    }

    async GetRealisations() {
        const resp = await fetch('/graphql', {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: '{realisations{id, slug, title, content, excerpt, thumb1, thumb2, thumb3}}',
            }),
            credentials: 'include',
        });
        const { data } = await resp.json();
        if (!data || !data.realisations) throw new Error('Erreur sur le chargement des réalisations !');

        this.setState({ realisations: data.realisations })
        
    }

    render(){

        return (
            <div className={s.root}>
                <div className={`realisationAccueil`}>
                    <div className={`container`}>
                        <div className={`wrapRealisation`}>
                            <div className={`left col-md-5`}>
                                <div className={`content`}>
                                    <span className={`titreRealisationAccueil`}>Réalisations</span>
                                    <div className={`texteRealisationAccueil`}>
                                        <p>{this.props.texteRealisation}</p>
                                    </div>
                                    <div className={`btnSite`}>
                                        <Link to="/realisations">{this.props.ctaRealisation}</Link>
                                    </div>
                                </div>
                            </div>
                            <div className={`right col-md-7`}>
                                <div className={`content`}>
                                    <ul>
                                    {this.state.realisations.slice(0, 3).map((item, index) => (
                                        <li key={index}>
                                            <Link to={`/realisations/${item.slug}`}>
                                                <div className={`boxRealAccueil`}>
                                                    <div className={`blackBox`}></div>
                                                    <div className={`box`}></div>
                                                    <div className={`boxInside`}></div>
                                                    <img className={`largeScreen`} src={item.thumb1} alt="Image pu projet" />
                                                    <img className={`smallScreen`} src={item.thumb1} alt="Image pu projet" />
                                                    <span className={`titreRealAccueil`}>{item.title}</span>
                                                    <span className={`texteRealAccueil`} dangerouslySetInnerHTML={{ __html: item.excerpt }} />
                                                    <span className={`texteRealAccueilHover`}>Consulter</span>
                                                </div>
                                            </Link>
                                        </li>
                                    ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}





// WEBPACK FOOTER //
// ./components/RealisationAccueil/RealisationAccueil.js